import { createSlice } from '@reduxjs/toolkit';
import { getTopLevelState } from '../thunk/landingPageThunk';
const initialState = {
  landingPageDetails: [],
  loading: false,
  updating: false,
  error: null,
};

const landigPageSlice = createSlice({
  name: 'ladingPage',
  initialState,
  reducers: {
    clearTopLevelLandingDetails: (state) => {
      state.landingPageDetails = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Contact Details
      .addCase(getTopLevelState.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopLevelState.fulfilled, (state, action) => {
        state.loading = false;
        state.landingPageDetails = action.payload.data;
      })
      .addCase(getTopLevelState.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTopLevelLandingDetails } = landigPageSlice.actions;
export default landigPageSlice.reducer;
